<template>
	<div ref="searchList" class="search-list">
		<div class="searchCondition gim-card">
			<slot/>
		</div>
		<div class="customAction">
			<div class="gim-custom-action">
				<div class="gim-select-input">
					<div class="gim-status-action">
					<slot name="statusAction"/>
					</div>
					<el-input v-if="searchKeys" ref='searchInput' v-model="searchValue" clearable size="small" style="width:340px;" @keydown.enter.native="refresh">
						<el-select :clearable="!notSearchAll" v-model="searchKey" slot="prepend" class="gim-select">
							<el-option v-for="(value,key) in searchKeys" :key="key" :label="value.label" :value="key" />
						</el-select>
					</el-input>
					<el-button v-if="!hideApply" class="bt-apply" type="primary" @click="refresh">apply</el-button>
				</div>
				<div class="gim-switch">
					<slot name="switchActions" />
				</div>
			</div>
			<div class="gim-custom-search">
				<slot name="customSearch"/>
			</div>
			<div class="gim-actions">
				<el-button class="gim-action-button gim-download-button" @click="getCsv"><i class="el-icon-download"></i></el-button>
				<el-button class="gim-action-button gim-copy-button" @click="openSelectColumnDialog"><i class="el-icon-document-copy"></i></el-button>
				<slot class="gim-action-button" name="actions" />
			</div>
		</div>
		<slot name="dataTable" :rows="rows" :summary="summary" />
		<div class="pagination gim-pagination">
			<el-pagination class="pagination" layout="sizes,prev, pager, next,total" :total="count" :page-sizes="pageSizes" :current-page.sync="page" :page-size.sync="pageSize" @size-change="pageSizeChange" @current-change="refresh" />
		</div>
		<el-dialog :visible.sync="selectColumnVisible">
			<span slot="title">Select Column</span>
			<el-form>
				<el-form-item label="Copy Column">
					<mm-select
						v-model="selectedCopyColumns"
						:options="currentColumnOptions"
						v-bind="$attrs"
						returnArray
						multiple
						v-on="$listeners"
						/>
				</el-form-item>
				<el-form-item label="With Title">
					<el-switch v-model="isWithTitle"></el-switch>
				</el-form-item>
				<el-form-item :label="`Connect with ','`">
					<el-switch v-model="connectWithCommas" :disabled="selectedCopyColumns.length !== 1"></el-switch>
					<el-tooltip class="item" effect="dark" content="Only effective when single selected" placement="right-start">
					<i class="el-icon-info" />
					</el-tooltip>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="copy">Copy</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import NProgress from 'nprogress'
export default {
	name: "search-list",
	data() {
		let searchKey = "";
		const keys = this.searchKeys?Object.keys(this.searchKeys):[];
		const firstSearchKey = keys[0];
		if(this.notSearchAll){
			searchKey = firstSearchKey;
		}
		return {
			rows: [],
			count: 0,
			summary:[],
			page: 1,
			pageSize: this.pageSizes[0],
			searchKey: searchKey,
			searchValue: "",
			firstSearchKey,
			copyText:'',
			rowsNum:0,
			selectColumnVisible: false,
			selectedCopyColumns: [],
			isWithTitle: false,
			connectWithCommas: false,
			currentColumnOptions: [],
		};
	},
	props: {
		pageSizes: {
			type: Array,
			default: () => {
				return [30, 50, 100];
			}
		},
		where: {
			type: Object,
			default: () => {
				return {};
			}
		},
		order: {
			type: Array,
			default: () => {
				return [];
			}
		},
		attributes:Array,
		apiPath: {
			require: true,
			type: String
		},
		searchKeys: {
			type: Object
		},
		hideApply: {
			type:Boolean,
			default:false,
		},
		handleResponse:{
			type:Function,
			default:null
		},
		notSearchAll:{
			type:Boolean,
			default:false,
		},
		autoRefresh:{
			type:Boolean,
			default:true
		},
		beforeRefresh:Function,
		copyFrom:Function,
	},
	methods: {
		getCondition() {
			const where = JSON.parse(JSON.stringify(this.where));
			const condition = {};
			if (this.searchValue) {
				const inputKey = this.searchKey;
				const reg = /^\s+|\s+$/g;
				let searchKey = inputKey || this.firstSearchKey;
				searchKey = this.searchKeys[searchKey]['key'] || searchKey;
				let searchValue = this.searchValue.replace(reg, '');
				if(/,/.test(searchValue)){
					searchValue = searchValue.split(',').map(v => v.replace(reg, ''));
					condition[searchKey] = {$in:searchValue};
				}
				else if (inputKey) {
					condition[searchKey] = this.searchKeys[inputKey].fuzzy
						? { $regex: `%${searchValue}%` }
						: searchValue;
				} else {
					condition["$or"] = [];
					for (let [k, v] of Object.entries(this.searchKeys)) {
						const r = v.fuzzy
							? { $regex: `%${searchValue}%` }
							: searchValue;
						condition["$or"].push({ [v.key||k]: r });
					}
				}
			}
			try {
				for (let [k, v] of Object.entries(where)) {
					if (!v && v !== 0) {
						continue;
					} else if (Array.isArray(v)) {
						if (v.length === 1) {
							condition[k] = v[0];
						} else if (v.length > 1) {
							condition[k] = { $in: v };
						}
					} else {
						condition[k] = v;
					}
				}
				
			} catch (e) {
				console.error(e);
			}
			return condition;
		},
		async refresh(pageSize) {
			try{
				this.beforeRefresh && await this.beforeRefresh();
			}catch(e){
				this.$message({message:e,type:'error',duration:2000});
				return ;
			}
			const body = await this.$post(this.apiPath, {
				where: this.getCondition(),
				attributes:this.attributes,
				offset: (this.page - 1) * this.pageSize,
				limit: this.pageSize,
				order: this.order
			});
			this.handleResponse && this.handleResponse(body);
			this.rows = body.rows;
			this.count = body.count;
			this.summary = body.summary;
		},
		async getCsv() {
			NProgress.start();
			NProgress.inc(0.5);
			const response = await this.$http.post(this.apiPath, {
				where: this.getCondition(),
				attributes:this.attributes,
				offset: 0,
				limit: 5000,
				isCsv:true
			},{responseType: 'arraybuffer'});
			NProgress.done();

			const blob = new Blob([response.data],{type:'text/csv'});
			const time = this.$utils.date_format((new Date()),'YYYY_MM_DD');
			const name_arr = this.apiPath.split('/');
			const file_name = name_arr[1] + '_' + time + '.csv';
			if(window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob,file_name);
			} else {
				const a = document.createElement('a');
				a.download = file_name;
				a.href = window.URL.createObjectURL(blob);
				a.click();
			}
		},
		openSelectColumnDialog() {
			this.currentColumnOptions = [];
			const tableObj = this.$children[this.$children.length-3].$children[0];
			for(const column of tableObj.store.states.originColumns) {
				if(column.property) {
					const obj = {
						value: column.property
					};
					if(column.filterPlacement!=''){
						obj.label = column.filterPlacement;
					}else{
						obj.label = column.label;
					}
					this.currentColumnOptions.push(obj);
				}
			}
			this.selectColumnVisible = true;
		},
		async copy() {
			console.log('this.selectedCopyColumns',this.selectedCopyColumns)
			if (!this.selectedCopyColumns.length) {
				this.$message.warning('Must be select column');
				return;
			}
			const title_name = {};
			let title = '';
			let text = '';
			let num = 0;
			for(const value of this.selectedCopyColumns) {
				const item = this.currentColumnOptions.find(row => row.value == value);
				title_name[value] = item.label;
			}
			// let name = this.rows[0];
			// for(const key in name) {
			// 	if(title_name[key] == null) {
			// 		title_name[key] = key;
			// 		summary_rows.push('--');
			// 	}
			// }
			let rows = JSON.parse(JSON.stringify(this.rows));
			rows = this.copyFrom?this.copyFrom(rows,title_name):rows;
			title = Object.values(title_name).join('\t') + '\r';
			for(const key in rows) {
				for(const name in title_name) {
					if(rows[key][name] != null) {
						if (typeof rows[key][name] === 'string') {
							text += (rows[key][name]).replace(/\t|\r|\n|\r\n/g, ' ') + '\t';
						} else if (typeof rows[key][name] === 'object') {
							text += JSON.stringify(rows[key][name]) + '\t';
						} else {
							text += rows[key][name] + '\t';
						}
					} else {
						text += '--\t';
					}
				}
				text = text.substring(0,text.length-1) + "\r";
				num++;
			}
			let copyText = this.isWithTitle ? title + text : text;
			if (this.connectWithCommas && this.selectedCopyColumns.length === 1) {
				copyText = copyText.replace(/\r/g, ',').replace(/,$/, '');
			}
			await this.$copyText(copyText);
			this.$message({
				type:'success',
				message:'Copied ' + num + ' rows to clipboard',
			})
			this.selectColumnVisible = false;
		},
		pageSizeChange(pageSize) {
			this.pageSize = pageSize;
			this.refresh();
		}
	},

	mounted() {
		this.autoRefresh && this.refresh();
		this.searchKeys;
		if (this.$cache.browse_model === 'web') {
			this.searchKeys && this.$refs.searchInput.focus()
		}
	}
};
</script>

<style scoped>
.search-list {
	display: flex;
	width: 98%;
	margin: 0 1%;
	height: 100%;
	flex-direction: column;
}
.searchCondition {
	display: flex;
	flex-direction: row;
	width: 100%;
	margin-top: 8px;
	margin-bottom: 8px;
	align-items: flex-start;
}
.customAction {
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: flex-end;
	justify-content: space-between;
	margin-bottom: 10px;
}
.gim-custom-search {
	flex: 1;
	margin: 0 10px;
	display: flex;
	align-items: center;
}
.gim-actions {
	display: flex;
	flex-direction: row-reverse;
	align-items: flex-end;
}
.gim-actions > button {
	margin: 0;
}
.gim-action-button {
  margin-left:0px;
}
.gim-custom-action {
	display: flex;
	align-items: center;
}
.pagination {
	width: auto;
}
.gim-pagination {
	width: 100%;
	display: flex;
	padding-bottom: 5px;
}
.gim-select-input, .gim-actions {
    border-radius: 100px;
    overflow: hidden;
    display: flex;
    height: 29px;
    align-items: center;
    border: 1px solid #ccc;
}
.bt-apply {
	background-color: #f6f5fa;
    border-color: #f6f5fa;
    color: #91949a;
}
.gim-download-button {
	background-color: #f0ab37;
	color: #fff;
}
.gim-copy-button {
	background-color: #6c70d6;
	color: #fff;
}
</style>

